import classNames from 'classnames'
import Image from 'next/legacy/image'
import useThriveAuth from 'hooks/useThriveAuth'
import styles from './index.module.scss'
import { dateFormats } from 'constants/common'
import { SlotAvailabilityType } from 'app/Bookings/constants'
import { availabilityIconMapping } from 'app/ProviderSearch/constants'
import { useContext } from 'react'
import { TimeZoneContext } from 'context/common/TimeZoneContext'

type SlotGridButtonProps = {
  buttonVariant?: string
  slotButtonClass?: string
  slot: ProviderSlot
  onSlotClick: () => void
  showSlotAvailabilityIcon: boolean
  slotAvailabilities?: SlotAvailabilityType[]
  isProviderPage?: boolean
  stackedLayout?: boolean // Stacks time and visit-type icons on separate rows
}

const SlotGridButton: React.FC<SlotGridButtonProps> = ({
  buttonVariant = '',
  slotButtonClass = '',
  slot,
  onSlotClick,
  showSlotAvailabilityIcon,
  slotAvailabilities,
  isProviderPage = false,
  stackedLayout = false,
}) => {
  const { format } = useContext(TimeZoneContext)
  const { isSupportOrThirdPartyUser } = useThriveAuth()

  const getSlotBtnText = (start: string | number) => {
    const slotBtnText = format(
      new Date(start),
      dateFormats.TIME_FORMAT
    ).toLowerCase()

    const slotBtnTextHourFormat = slotBtnText.replace(/:00/g, '')

    return slotBtnTextHourFormat
  }

  return (
    <button
      type="button"
      className={classNames(
        'btn',
        buttonVariant && `btn-${buttonVariant}`,
        styles.slot_button,
        stackedLayout && styles.stacked_layout,
        slotButtonClass
      )}
      onClick={onSlotClick}
    >
      {stackedLayout ? (
        <span className={styles.slot_time}>{getSlotBtnText(slot.start)}</span>
      ) : (
        getSlotBtnText(slot.start)
      )}
      {(isSupportOrThirdPartyUser || showSlotAvailabilityIcon) && (
        <div
          className={classNames(styles.slot_availability, 'd-flex', {
            'mt-1':
              !isProviderPage && showSlotAvailabilityIcon && !stackedLayout,
            '~gap-1': stackedLayout,
          })}
        >
          {slotAvailabilities.map((slotAvailability) => (
            <div
              key={slotAvailability}
              className="d-flex justify-content-start"
            >
              <Image
                src={availabilityIconMapping[slotAvailability]}
                alt={slotAvailability}
                height={isProviderPage ? '10' : '14'}
                width={isProviderPage ? '10' : '14'}
                unoptimized
              />
            </div>
          ))}
        </div>
      )}
    </button>
  )
}

export default SlotGridButton
